import { createContext, useContext } from 'react';
import { Map } from 'immutable';
import { makeUniqueDomId } from '@dbh/dom';

const REDUX_AND_SAGA_KEY="HdpPage";const hdpDiscoverTargetId=makeUniqueDomId("hdp-discover-target");const hdpDiscoverTargetIdHref="#".concat(hdpDiscoverTargetId);// Feature flag that enables the unique `UI` for the "other services" tab.
const ENABLE_OTHER_SERVICES_FEATURE_FLAG=!1;

const hdpPageContextDefaultValue=Map({hdpDiscoverTargetId});const HdpPageContext=/*#__PURE__*/createContext(hdpPageContextDefaultValue);

const useHdpPageContext=()=>useContext(HdpPageContext);var useHdpPageContext$1 = useHdpPageContext;

// @see {@link https://reactjs.org/docs/context.html#reactcreatecontext}
const TabsContext=/*#__PURE__*/createContext(),{Provider:TabsContextProvider}=TabsContext;

export { ENABLE_OTHER_SERVICES_FEATURE_FLAG, HdpPageContext, REDUX_AND_SAGA_KEY, TabsContext, TabsContextProvider, hdpDiscoverTargetId, hdpDiscoverTargetIdHref, hdpPageContextDefaultValue, useHdpPageContext$1 as useHdpPageContext };
